import {Expose} from 'class-transformer';

export class DescriptiveAnnexUpdateDto {
    @Expose({name: 'paragraph_one_content'})
    paragraphOneContent: string = null;

    constructor(props?: Partial<DescriptiveAnnexUpdateDto>) {
        Object.assign(this, props);
    }
}
